import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/videos';

export default function HeroBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20cinema%20atmosphere%20with%20abstract%20geometric%20film%20reel%20elements%20and%20flowing%20gradient%20shapes%20in%20warm%20coral%20and%20gold%20tones%2C%20artistic%20minimalist%20design%2C%20dark%20theater%20curtain%20edges%2C%20dramatic%20cinematic%20lighting%2C%20elegant%20composition%2C%204K%20quality&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
        alt="国产在线观看 - 高清免费影视平台"
        title="国产在线观看精选海量高清影视内容"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          {t('home.heroTitle')}
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mb-8 leading-relaxed">
          {t('home.heroSubtitle')}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/category/dianshiju"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-fill w-4 h-4 flex items-center justify-center inline-block mr-1.5"></i>
            {t('home.heroCta')}
          </Link>
          <Link
            to="/category/dianying"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-movie-line w-4 h-4 flex items-center justify-center inline-block mr-1.5"></i>
            电影专区
          </Link>
        </div>
      </div>

      {/* Category quick nav */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="px-4 md:px-6">
          <div className="flex items-center justify-center gap-1 md:gap-2 pb-6 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-1.5 px-4 py-2 bg-white/15 backdrop-blur-sm rounded-full text-sm text-white hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}